import React, { Component } from "react";

import { MenuItem } from "@material-ui/core";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import * as geom from "js/core/utilities/geom";

import { BlockStyleType } from "common/constants";
import { $ } from "js/vendor";
import { PopupMenu } from "js/react/components/PopupMenu";
import { ColorPicker } from "js/react/components/ColorPicker";
import { NestedMenuItem } from "js/react/components/NestedMenuItem";

import { ResizeHandle } from "../../../authoring/SelectionUI";
import { BoundsBox, ReverseScaleBox } from "../../../authoring/SelectionBox";

import { ControlBar } from "../../../EditorComponents/ControlBar";

export class ElementBlockEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEditing: false
        };
    }

    componentDidMount() {
        // console.log("ElementBlockEditor::mount");
        // ds.selection.element = this.props.block.element;

        const { block } = this.props;

        // bind listeners to events on the canvas TextBlock contentEditable ref
        // $(block.ref.current).on("mouseup.elementblockeditor", this.handleEdit);
        this.setState({ isEditing: true });

        block.setState({ isEditing: true });
    }

    componentWillUnmount() {
        // console.log("ElementBlockEditor::unmount");
        this.setState({ isEditing: false });
    }

    handleEdit = () => {
        // console.log("ElementBlockEditor::EDIT");
        let element = this.props.block.element;
        // ds.selection.element = element;

        // app.mainView.editorView.selectionLayer.editingDocElement = element;
        // app.mainView.editorView.selectionLayer.showElementSelection();

        this.setState({ isEditing: true });
    }

    handleChangeElementType = type => {
        this.props.block.model.elementModel = {
            elementType: type
        };
        app.currentCanvas.updateCanvasModel();
    }

    handleChangeBackgroundColor = color => {
        this.props.block.model.backgroundColor = color;
        app.currentCanvas.updateCanvasModel();
    }

    handleChangeBlockStyle = (style, color) => {
        this.props.block.model.blockStyle = style;
        this.props.block.model.blockColor = color;
        app.currentCanvas.updateCanvasModel();
    }

    handleResizeHandleMouseDown = event => {
        const { bounds, block, refreshCanvasAndSaveChanges, refreshElement } = this.props;

        event.stopPropagation();

        let top = block.element.DOMNode.getBoundingClientRect().y;
        // let top = bounds.top;

        app.isDragging = true;

        $(document).on("mousemove.resize", event => {
            event.stopPropagation();
            // console.log(event.pageY, top, event.pageY - top);
            let height = (event.pageY - top) / app.currentCanvas.getScale();
            block.model.blockHeight = Math.clamp(height, 50, 1000);
            refreshElement();
        });

        $(document).on("mouseup.resize", event => {
            app.isDragging = false;
            event.stopPropagation();
            $(document).off(".resize");
            refreshCanvasAndSaveChanges();
            ds.selection.element = null;
        });
    }

    render() {
        const { bounds, block } = this.props;
        const { isEditing } = this.state;

        return (
            <BoundsBox bounds={bounds} className="element-block-editor-container">
                {/* inner div reverse scales contenteditable so that selection layer coordinate-space matches canvas */}
                <ReverseScaleBox bounds={bounds} style={{ pointerEvents: isEditing ? "none" : "auto" }}>
                </ReverseScaleBox>
            </BoundsBox>
        );
    }
}
